module.exports = __webpack_public_path__ + "static/media/details-2-image-3.a24ff836.jpg";